// extracted by mini-css-extract-plugin
export var videoHero = "_4g-4";
export var videoHeroImage = "_4g-5";
export var videoHeroOverlay = "_4g-6";
export var videoHeroSubtitle = "_4g-8";
export var videoHeroText = "_4g-7";
export var videoLauncher = "_4g-0";
export var videoLauncherIcon = "_4g-1";
export var videoLauncherSubtitle = "_4g-3";
export var videoLauncherTitle = "_4g-2";
export var videoPlayer = "_4g-a";
export var videoPlayerWrap = "_4g-9";